<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" *ngIf="authenticationService.isAuthenticated | async">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header>
            <ion-text color="primary">moveUP Med</ion-text>
          </ion-list-header>
          <ion-note *ngIf="userEmail">{{userEmail}}</ion-note>

          @for (p of appPages; track p; let i = $index) {
            <ion-menu-toggle auto-hide="false" *ngIf="p.show">
              <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-outline'"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>

        <!--<ion-list id="labels-list">
          <ion-list-header>Filter</ion-list-header>

          @for (label of labels; track label) {
            <ion-item lines="none">
              <ion-icon aria-hidden="true" slot="start" ios="bookmark-outline" md="bookmark-outline"></ion-icon>
              <ion-label>{{ label }}</ion-label>
            </ion-item>
          }
        </ion-list>-->
        <ion-list id="account-list">
          <ion-item lines="none" [button]="true" (click)="logout()">
            <ion-icon aria-hidden="true" slot="start" ios="log-out-outline" md="log-out-outline"></ion-icon>
            <ion-label>Logout</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
